import React, { createContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const ProjectSourcesContext = createContext({
  info: [],
  setInfo: () => { },
  userRoles: [],
  setUserRoles: () => { },
  userRolesFetched: false,
  setUserRolesFetched: () => { },
  adminUserRolesFetched: false,
  setAdminUserRolesFetched: () => { },
  adminUserRoles: false,
  setAdminUserRoles: () => { },
});

export const ProjectSourcesProvider = ({ children }) => {
  const { user } = useSelector((state) => state.authentication);
  const [info, setInfo] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [userRolesFetched, setUserRolesFetched] = useState(false);
  const [adminUserRoles, setAdminUserRoles] = useState([]);
  const [adminUserRolesFetched, setAdminUserRolesFetched] = useState(false);

  useEffect(() => {
    setAdminUserRolesFetched(false);
  }, [user?.language]);

  return (
    <ProjectSourcesContext.Provider
      value={{
        info, setInfo, userRoles, setUserRoles, userRolesFetched, setUserRolesFetched,
        adminUserRolesFetched, setAdminUserRolesFetched, adminUserRoles, setAdminUserRoles,
      }}
    >
      {children}
    </ProjectSourcesContext.Provider>
  )
};
